<kt-portlet>
    <kt-portlet-header [title]="getComponentTitle()" [class]="'class-head-lg'"
        [tooltipTitle]="'TOOLTIP.HOUSE.FORM' + (acHouse && acHouse.id > 0 ? '_EDIT' : '') + '.TITLE' | translate"
        [tooltipDesc]="'TOOLTIP.HOUSE.FORM' + (acHouse && acHouse.id > 0 ? '_EDIT' : '') + '.DESCRIPTION' | translate"
        [viewLoading$]="loading$" [sticky]="true">
        <ng-container ktAdditionalTools>
            <div class="btn-group btn-group-toggle" role="group" ngbRadioGroup name="radioBasic"
                [formControl]="formSelectionCtrl">
                <label ngbButtonLabel class="btn btn-secondary width-130 btn-border-right-white">
                    <input ngbButton type="radio" class="btn-check" [value]="2"> Simple
                </label>
                <label ngbButtonLabel class="btn btn-secondary width-130 btn-border-left-white">
                    <input ngbButton type="radio" class="btn-check" [value]="1"> Advanced
                </label>
            </div>
        </ng-container>
        <ng-container ktPortletTools>
            <a href="javascript:;" (click)="back()" class="btn mr-2" mat-raised-button matTooltip="Back to Land List">
                <mat-icon>arrow_back</mat-icon>
                <span class="kt-hidden-mobile">Close</span>
            </a>
            <a href="javascript:;" color="warn" (click)="onSubmit(false)" class="btn btn-success mr-2"
                style="background-color: orange !important;" mat-raised-button matTooltip="Save to Draft">
                <span>Save draft</span>
            </a>
            <a href="javascript:;" color="submit" (click)="onSubmit(true)" class="btn btn-success mr-2"
                mat-raised-button matTooltip="Save">
                <span class="kt-hidden-mobile">Save</span>
            </a>
        </ng-container>
    </kt-portlet-header>

    <kt-portlet-body>
        <form class="form" [formGroup]="formGroup">
            <!-- <kt-tab-header 
                [headerLabels]="tabHeaders" 
                (tabChange)="onTabChange($event)"
                [selectedTabChange]="selectedtabchange$">
            </kt-tab-header> -->
            <kt-form-tab-header [headers]="formTabHeaders$|async"
                (tabChange)="onTabChange($event)"></kt-form-tab-header>
            <mat-tab-group class="invinsible-tabs" [(selectedIndex)]="selectedTab"
                (selectedTabChange)="onTabChanged($event);">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span>Location & Land Identification</span>
                    </ng-template>
                    <div class="card-body pt-0 mad-container">
                        <app-comparable-location
                            [centerLatitude]="centerLat"
                            [centerLongitude]="centerLng"
                            [locationInfo]="locationInfo"
                            (centerChange)="onCenterChange($event)"
                            (markerChange)="onMarkerChange($event)"
                        ></app-comparable-location>

                        <app-parcel-identification *ngIf="isComplexForm" class="section-margin-top-60"
                            [form]="formGroup.controls.parcel_identification" [centerLat]="centerLat"
                            [centerLng]="centerLng" [coordinatePoints]="coordinatePoints$|async"
                            [landAreas]="landAreas$|async" [marker]="markerInfo"
                            (coordinatePointsChange)="onCoordinatePointsChange($event)"
                            (landAreasChange)="onLandAreasChange($event)"></app-parcel-identification>
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span>Property information</span>
                    </ng-template>
                    <div class="card-body pt-0 mad-container">
                        <!-- About the property section -->
                        <div class="form-group kt-form__group row section-margin-top-60">
                            <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                <h5 class="my-3 text-mad text-uppercase">
                                    About the property
                                </h5>
                                <hr class="active">
                            </div>

                            <div class="col-lg-4 kt-margin-bottom-20-mobile">
                                <mat-form-field class="mat-form-field-fluid"
                                    [formFieldState]="formGroup.controls['sub_type_category_id']">
                                    <mat-select placeholder="Sub-type category" formControlName="sub_type_category_id">
                                        <mat-option *ngFor="let item of subTypeCategories"
                                            [value]="item.id">{{item.name}}</mat-option>
                                    </mat-select>
                                    <mat-hint [formFieldHintState]="formGroup.controls['sub_type_category_id']">
                                        Sub-type category <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Sub-type category <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="filteredSubCategories.length != 0">
                                <mat-form-field class="mat-form-field-fluid"
                                    [formFieldState]="formGroup.controls['sub_category_id']">
                                    <mat-select placeholder="Sub-category" formControlName="sub_category_id">
                                        <mat-option *ngFor="let item of filteredSubCategories"
                                            [value]="item.id">{{item.name}}</mat-option>
                                    </mat-select>
                                    <mat-hint [formFieldHintState]="formGroup.controls['sub_category_id']">
                                        Sub-category <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Sub-category <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-lg-4">
                                <mat-form-field class="mat-form-field-fluid">
                                    <input matInput placeholder="Property ID" formControlName="property_id" />
                                </mat-form-field>
                            </div>

                            <div class="col-lg-4 kt-margin-bottom-20-mobile">
                                <mat-form-field class="mat-form-field-fluid"
                                    [formFieldState]="formGroup.controls['property_grade_id']">
                                    <mat-select placeholder="Property grade" formControlName="property_grade_id">
                                        <mat-option *ngFor="let item of grades"
                                            [value]="item.id">{{item.name}}</mat-option>
                                    </mat-select>
                                    <mat-hint [formFieldHintState]="formGroup.controls['property_grade_id']">
                                        Property grade <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Property grade <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="isComplexForm">
                                <mat-form-field class="mat-form-field-fluid">
                                    <input matInput placeholder="Property general description"
                                        formControlName="general_desc" />
                                </mat-form-field>
                            </div>

                            <div class="col-lg-4 kt-margin-bottom-20-mobile">
                                <mat-form-field class="mat-form-field-fluid"
                                    [formFieldState]="formGroup.controls['completion_year']">
                                    <input matInput placeholder="Completion year" formControlName="completion_year" />
                                    <mat-hint [formFieldHintState]="formGroup.controls['completion_year']">
                                        Completion year <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Completion year <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="isComplexForm">
                                <mat-form-field class="mat-form-field-fluid">
                                    <input matInput placeholder="Approximate year the property was extended"
                                        formControlName="apprx_year_extended" />
                                </mat-form-field>
                            </div>

                            <div class="col-lg-4 kt-margin-bottom-20-mobile">
                                <mat-form-field class="mat-form-field-fluid"
                                    [formFieldState]="formGroup.controls['state_of_repair_id']">
                                    <mat-select placeholder="State of repair" formControlName="state_of_repair_id">
                                        <mat-option *ngFor="let item of stateOfRepairs"
                                            [value]="item.id">{{item.name}}</mat-option>
                                    </mat-select>
                                    <mat-hint [formFieldHintState]="formGroup.controls['state_of_repair_id']">
                                        State of Repair <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        State of Repair <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-lg-4 kt-margin-bottom-20-mobile">
                                <mat-form-field class="mat-form-field-fluid"
                                    [formFieldState]="formGroup.controls['handover_standard_id']">
                                    <mat-select placeholder="Handover standard" formControlName="handover_standard_id">
                                        <mat-option *ngFor="let item of handoverStandards"
                                            [value]="item.id">{{item.name}}</mat-option>
                                    </mat-select>
                                    <mat-hint [formFieldHintState]="formGroup.controls['handover_standard_id']">
                                        Handover standard <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Handover standard <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="!isComplexForm">
                                <mat-form-field class="mat-form-field-fluid"
                                    [formFieldState]="formGroup.controls['number_of_rooms']">
                                    <input matInput type="text" mask="0000" [validation]="false"
                                        placeholder="Number of rooms" formControlName="number_of_rooms" />
                                    <mat-hint [formFieldHintState]="formGroup.controls['number_of_rooms']">
                                        Number of rooms <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Number of rooms <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="!isComplexForm">
                                <mat-form-field class="mat-form-field-fluid"
                                    [formFieldState]="formGroup.controls['number_of_bedrooms']">
                                    <input matInput type="text" mask="0000" [validation]="false"
                                        placeholder="Number of bedrooms" formControlName="number_of_bedrooms" />
                                    <mat-hint [formFieldHintState]="formGroup.controls['number_of_bedrooms']">
                                        Number of bedrooms <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Number of bedrooms <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="!isComplexForm">
                                <mat-form-field class="mat-form-field-fluid"
                                    [formFieldState]="formGroup.controls['number_of_bathrooms']">
                                    <input matInput type="text" mask="0000" [validation]="false"
                                        placeholder="Number of bathrooms" formControlName="number_of_bathrooms" />
                                    <mat-hint [formFieldHintState]="formGroup.controls['number_of_bathrooms']">
                                        Number of bathrooms <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Number of bathrooms <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="isComplexForm">
                                <mat-form-field class="mat-form-field-fluid">
                                    <mat-select placeholder="Foundation type" formControlName="foundation_type_id">
                                        <mat-option *ngFor="let item of foundationTypes"
                                            [value]="item.id">{{item.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-lg-4 kt-margin-bottom-20-mobile">
                                <mat-form-field class="mat-form-field-fluid"
                                    [formFieldState]="formGroup.controls['above_floors']">
                                    <input matInput type="text" mask="0000" [validation]="false"
                                        placeholder="Number of floors (above ground)" formControlName="above_floors" />
                                    <mat-hint [formFieldHintState]="formGroup.controls['above_floors']">
                                        Number of floors <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Number of floors <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-lg-4 kt-margin-bottom-20-mobile">
                                <mat-form-field class="mat-form-field-fluid">
                                    <input matInput type="text" mask="0000" [validation]="false"
                                        placeholder="Basement floors" formControlName="below_floors" />
                                </mat-form-field>
                            </div>

                            <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                <mat-form-field class="mat-form-field-fluid">
                                    <textarea matInput rows="3" placeholder="Construction description"
                                        formControlName="construction_desc"></textarea>
                                </mat-form-field>
                            </div>

                            <div class="col-lg-12 mt-10" *ngIf="isComplexForm">
                                <kt-accommodation-layout-table [propertySubTypeID]="17" [aboveFloor]="aboveFloor$"
                                    [belowFloor]="belowFloor$" [floors$]="floors$"
                                    [initData]="acHouse.accommodation.data"
                                    [initOthers]="acHouse.accommodation.others"></kt-accommodation-layout-table>
                            </div>
                        </div>


                        <div class="form-group kt-form__group row section-margin-top-60">
                            <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                <h5 class="my-3 text-mad text-uppercase">
                                    Services and Infrastructures
                                </h5>
                                <hr class="active">
                            </div>
                            <div class="col-lg-12">
                                <kt-services-and-infrastructures [isComplexForm]="isComplexForm"
                                    [serviceAndInfraData]="acHouse.serviceAndInfraData"></kt-services-and-infrastructures>
                            </div>
                        </div>

                        <div class="form-group kt-form__group row section-margin-top-60" *ngIf="isComplexForm">
                            <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                <h5 class="my-3 text-mad text-uppercase">
                                    External Aspect
                                </h5>
                                <hr class="active">
                            </div>
                            <div class="col-lg-12">
                                <kt-external-aspects [propertySubTypeID]="17" [formType]="'comparable'"
                                    [externalAspectData]="acHouse.externalAspectData"></kt-external-aspects>
                            </div>
                        </div>

                        <div class="form-group kt-form__group row section-margin-top-60" *ngIf="isComplexForm">
                            <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                <h5 class="my-3 text-mad text-uppercase">
                                    Internal Aspect
                                </h5>
                                <hr class="active">
                            </div>
                            <div class="col-lg-12">
                                <kt-internal-aspects [propertySubTypeID]="17" [formType]="'comparable'"
                                    [internalAspectData]="acHouse.internalAspectData"></kt-internal-aspects>
                            </div>
                        </div>

                        <div class="form-group kt-form__group row section-margin-top-60">
                            <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                <h5 class="my-3 text-mad text-uppercase">
                                    Grounds
                                </h5>
                                <hr class="active">
                            </div>
                            <div class="col-lg-12">
                                <kt-ac-grounds [isComplexForm]="isComplexForm" [propertySubTypeID]="17"
                                    [initData]="acHouse.grounds"></kt-ac-grounds>
                            </div>
                        </div>
                        <kt-ac-size class="section-margin-top-60" [sizesSubject]="sizesSubject"
                            [assetClassType]="'17'"></kt-ac-size>
                        <mat-error errorStateWithLength [hasFormError]="hasFormErrors"
                            [isInValid]="sizesSubject.value.length === 0" [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                                field: ('RETAIL_SHOP.FORM.FIELD.SIZES.SECTION_TITLE' | translate)
                            }">
                        </mat-error>
                    </div>
                </mat-tab>
                <mat-tab>
                    <kt-esg-indicators formType="comparable" [value]="acHouse.esgIndicator"
                        [systemOfMeasurement]="userUnitOfMeasurementId$|async" />
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span>Lease & sale information</span>
                    </ng-template>
                    <div class="card-body pt-0 mad-container">
                        <kt-consideration-and-source style="margin-top: 60px;"
                            [inputConsiderations]="tenuresSubject|async"
                            [landAreaComponentListSubject]="landAreaComponentListSubject"
                            [hasParcelInfo$]="hasParcelInfo$" [timezoneOffset]="timezoneOffset" [sizes]="sizes$|async"
                            (considerationsChange)="onConsiderationsChange($event)"></kt-consideration-and-source>
                        <mat-error errorStateWithLength [hasFormError]="hasFormErrors"
                            [isInValid]="considerationError$|async">
                            Input <strong>required</strong>
                        </mat-error>
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span>Pictures & documents</span>
                    </ng-template>
                    <div class="card-body pt-0 mad-container">
                        <div class="form-group row section-margin-top-60">
                            <div class="col-lg-12">
                                <h5 class="my-3 text-mad text-uppercase">
                                    Pictures
                                </h5>
                                <hr class="active">
                            </div>
                            <kt-upload-file #simple class="col-lg-12" [filesOnEditMode]="acHouse.ac_pictures"
                                [folderOnEditMode]="acHouse.picture" [readOnly]="false" [parentForm]="'land'"
                                [typeField]="false" fileType="image/*" split="1" [featuredPictureAllowed]="true"
                                [hasThumbnail]="true" [addButtonLabel]="'Add House Picture'">
                            </kt-upload-file>
                            <div class="col-md-12 kt-margin-bottom-20-mobile">
                                <mat-error class="tag-custom-error"
                                    *ngIf="hasFormErrors && showTitleRequiredError$|async">
                                    Picture should have a <strong>Title</strong>
                                </mat-error>
                            </div>
                        </div>
                        <kt-ac-document-upload *ngIf="isComplexForm" class="section-margin-top-60"
                            [files]="acHouse.documents">
                        </kt-ac-document-upload>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </form>
    </kt-portlet-body>
</kt-portlet>